import React from "react";
import { useNavigate } from "react-router-dom";
import { FaBolt, FaTimes } from "react-icons/fa";

interface AICreditsLimitModalProps {
  onClose: () => void;
}

const AICreditsLimitModal: React.FC<AICreditsLimitModalProps> = ({
  onClose,
}) => {
  const navigate = useNavigate();

  const handleTopUp = () => {
    onClose();
    navigate("/ai-credits");
  };

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center p-4">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6 flex flex-col items-center gap-4">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <FaTimes size={16} />
        </button>

        {/* Icon */}
        <div className="w-14 h-14 rounded-full bg-amber-100 flex items-center justify-center">
          <FaBolt className="text-amber-500" size={26} />
        </div>

        {/* Heading */}
        <div className="text-center">
          <h2 className="text-lg font-black text-gray-900 mb-1">
            AI Credits Exhausted
          </h2>
          <p className="text-sm text-gray-500 leading-relaxed">
            Your AI credit limit has been exceeded. Top up your wallet to
            continue using AI features.
          </p>
        </div>

        {/* Actions */}
        <div className="flex gap-3 w-full mt-1">
          <button
            onClick={onClose}
            className="flex-1 py-2.5 rounded-xl border-2 border-gray-200 text-sm font-black text-gray-600 hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleTopUp}
            className="flex-1 py-2.5 rounded-xl bg-gradient-to-r from-amber-500 to-orange-500 text-sm font-black text-white shadow-md hover:shadow-lg hover:from-amber-600 hover:to-orange-600 transition-all flex items-center justify-center gap-2"
          >
            <FaBolt size={13} />
            Top Up Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default AICreditsLimitModal;
